var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/micro/16/devices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/16/devices",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.33333333,
    y: 1.33333333,
    width: 9.33333333,
    height: 5.33333333,
    rx: 1.33333337
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.33333333,
    y: 9.33333333,
    width: 13.3333333,
    height: 5.33333333,
    rx: 1.33333337
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 5.33333333,
    y2: 12,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 12,
    y2: 12,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.451f4c4cdeaaa46826e8e224a9bb3bde.svg";
export { ForwardRef as ReactComponent };